import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import FormLabel from '../label';

class SelectField extends Component {
  constructor(props) {
    super(props);
    this.getSelectFieldText = this.getSelectFieldText.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.state = {
      selectedOption: props.value,
      dropdownOpen: false,
      searchText: '',
      searchResultsOptions: props.options,
    };
  }

  getSelectFieldText() {
    if (this.props.htmlTextPresent) {
      return this.props.htmlValue;
    } else if (this.props.initialValuePresent) {
      return this.props.value;
    }
    return this.state.selectedOption ? this.state.selectedOption : this.props.placeholder;
  }

  handleChange(selectedOption) {
    const { sendKeyValueOnChange, options } = this.props;

    let keyValue;
    if (sendKeyValueOnChange) {
      keyValue = options.filter(option => option.value === selectedOption)[0].key;
    }
    this.props.onBlur({
      target: {
        id: this.props.id,
        value: sendKeyValueOnChange ? keyValue : selectedOption,
      },
    });
    this.setState({ selectedOption, initialValuePresent: false });
  }

  toggle() {
    // calling a parent component function when clicks on dropdown
    const { parentCompFunction, options } = this.props;
    if (parentCompFunction) {
      parentCompFunction();
    }
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
      searchText: '',
      searchResultsOptions: options,
    }));
  }

  handleSearch(event) {
    const searchText = event.target.value;
    const searchResults = this.props.options.filter(opt => opt.value.toLowerCase().includes(searchText.toLowerCase()));
    this.setState({
      searchText,
      searchResultsOptions: searchResults,
    });
  }

  render() {
    const { selectedOption } = this.state;
    const { id, label, options, disabled, initialValuePresent, htmlTextPresent, showScrollBar } = this.props;
    return (
      <React.Fragment>
        {label && (
          <FormLabel
            label={label}
            forId={id}
          />
        )}
        <Dropdown
          className={`select-field ${disabled ? 'disabled' : ''} ${selectedOption.length > 0 || initialValuePresent ? '' : 'placeholder'}`}
          isOpen={this.state.dropdownOpen}
          toggle={this.toggle}
        >
          <DropdownToggle>
            {disabled ? '' : renderHTML(this.getSelectFieldText())}
          </DropdownToggle>
          {this.props.searchCapable &&
            <input
              type="text"
              id="ri-dropdown-search-special"
              value={this.state.searchText}
              onChange={this.handleSearch}
              placeholder="Search..."
              className={`${this.state.dropdownOpen ? 'ri-dropdown-search-special ri-search-show' : 'ri-dropdown-search-special ri-search-hide'}`}
            />
          }
          <DropdownMenu
            modifiers={{
              setMaxHeight: {
                enabled: showScrollBar,
                order: 890,
                fn: (data) => { // eslint-disable-line
                  return {
                    ...data,
                    styles: {
                      ...data.styles,
                      overflow: 'auto',
                      maxHeight: 250,
                      top: this.props.searchCapable ? '50%' : 0,
                    },
                  };
                },
              },
            }}
          >
            {this.props.searchCapable === undefined && options.map((option, index) => (
              <DropdownItem
                className={(initialValuePresent && this.props.value === option.value)
                  || (!initialValuePresent && option.value === selectedOption) ? 'is-selected' : ''}
                onClick={() => this.handleChange(option.value)}
                key={index.toString()}
              >
                {htmlTextPresent ? renderHTML(option.htmlText) : renderHTML(option.value)}
              </DropdownItem>
            ))}
            {this.props.searchCapable && this.state.searchResultsOptions.map((option, index) => (
              <DropdownItem
                className={(initialValuePresent && this.props.value === option.value)
                  || (!initialValuePresent && option.value === selectedOption) ? 'is-selected' : ''}
                onClick={() => this.handleChange(option.value)}
                key={index.toString()}
              >
                {htmlTextPresent ? renderHTML(option.htmlText) : renderHTML(option.value)}
              </DropdownItem>
            ))}

          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}

export default SelectField;
